import React from 'react';
import styles from './TimeIntervalButton.module.scss';
import { parseToTimeCode } from 'utilities';
import { Icon } from 'components/common';
import { icons } from 'assets';
import { inject } from 'mobx-react';
import { EDITOR_TIMELINE_STORE } from 'store';
import { TimeIntervalButtonProps } from './types';

const TimeIntervalButton = (props: TimeIntervalButtonProps) => {
  const {
    couple = null,
    interval = null,
    [EDITOR_TIMELINE_STORE]: {
      goToFrame
    }
  } = props;
  const [hovering, setHovering] = React.useState(false);
  const startFrame = couple
    ? couple.I.t
    : interval.startFrame;
  const endFrame = couple
    ? couple.O.t
    : interval.endFrame;

  return (
    <div
      className={styles.container}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      title='Go to frame'
      onClick={() => goToFrame(startFrame)}
    >
      {parseToTimeCode(startFrame)} - {parseToTimeCode(endFrame)}

      {hovering && <Icon icon={icons.arrowFillRight} />}
    </div>
  );
};

export default inject(EDITOR_TIMELINE_STORE)(TimeIntervalButton);
